module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMlJREFUKBWV0T0OwjAMBWDbhR6gEpyBlZmRggSCiZmDMXAENgRLGZm5ByAO0J+EvlQFWpoUIkVZnr84MVHLus7CIXZLjNgVAKBUFiEj4oX9Y3Sx5a3QG9FBUcwPF9YIVRDm2EBa+0R27AuqI57IClCm1I4cWAVqQnqH0x7QbT5euLAX5EIAYbkwA/2CFJQd4/tyOkjj5EyUTyf/WPxJ+ZyyuH7WO+v43ZGoNFn/gwDFRWYIZqI6gCFavC0zb0R40tbJZ2fIoga1MJ4/IZ50D6hwTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/TiiVii/icon-right-arrow-1.png
// module id = 3K5x
// module chunks = 0